import { ChipArrayField } from 'admin/fields/ChipArrayField';
import { UserInput } from 'admin/inputs/UserInput';
import { Datagrid, DateField, EditButton, List, TextField } from 'react-admin';

import { USER_ROLES } from './userUtils';

export const UserList: React.FC = () => {
  const filters = [<UserInput label="Používateľ" source="id" />];

  return (
    <List exporter={false} filters={filters} sort={{ field: 'creationTimestamp', order: 'DESC' }}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField label="ID" source="id" />
        <TextField label="Meno" source="name" />
        <TextField label="Priezvisko" source="surname" />
        <TextField label="E-mail" source="email" />
        <TextField label="Tel." source="phoneNumber" />
        <ChipArrayField choices={USER_ROLES} label="Role" sortable={false} source="roles" />
        <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
